import React from "react";

export default function Marquee({ items }) {
  const content = [...items, ...items];
  return (
    <div className="relative overflow-hidden bg-sage py-5 text-cream" data-testid="editorial-marquee">
      <div className="marquee-track">
        {content.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-serif text-2xl italic md:text-3xl">
            {t}
            <span className="text-honey-soft not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
